import { useMemo } from "react"

import { useNetworksStateContext } from "../contexts/NetworksContext"

export function useGetEnabledModulesInApp(app) {

    const { selectedNetwork, selectedSubNetworkSlugs } = useNetworksStateContext()

    const enabledModules = useMemo(() => {
        if (selectedNetwork) {
            return Object.values(app.modules)
                .filter(app => app.label)
                .sort((a, b) => a.index - b.index)
                .filter((moduleSettings) => {
                    const enabledModules = selectedNetwork.children?.length ? selectedNetwork.children
                        .filter(child => selectedSubNetworkSlugs.includes(child.slug))
                        .flatMap(child => child.modules)
                        : selectedNetwork.modules

                    const enabled = enabledModules.includes(moduleSettings.id)
                        || moduleSettings?.enablersModules?.some(enablerModule => {
                            return enabledModules?.includes(enablerModule)
                        })
                        || moduleSettings?.mandatoryModules?.every(mandatoryModule => {
                            return enabledModules?.includes(mandatoryModule)
                        })
                    return enabled
                })
        }
        return []
    }, [app, selectedNetwork, selectedSubNetworkSlugs])

    return enabledModules
}

export function useGetAvailableSubnetworkForModule(module) {

    const { selectedNetwork, selectedSubNetworkSlugs } = useNetworksStateContext()

    const currentSubNetworksWithModule = useMemo(() => {
        if (selectedNetwork) {
            const result = selectedSubNetworkSlugs?.filter(selectedSubNetworkSlug => {
                const subNetwork = selectedNetwork.children?.find(child => child.slug === selectedSubNetworkSlug)
                return subNetwork?.modules?.includes(module)
            })
            return result
        }
        return null
    }, [module, selectedNetwork, selectedSubNetworkSlugs])

    return currentSubNetworksWithModule
}

export function useGetAvailableSubnetworkCountForModule(module) {

    const currentSubNetworksWithModule = useGetAvailableSubnetworkForModule(module)
    const { selectedSubNetworkSlugs } = useNetworksStateContext()

    const subNetworksCount = useMemo(() => {
        if (selectedSubNetworkSlugs?.length !== currentSubNetworksWithModule?.length) {
            return currentSubNetworksWithModule.length
        }
        return null
    }, [selectedSubNetworkSlugs, currentSubNetworksWithModule])

    return subNetworksCount
}